import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useState } from 'react';
import { RootState } from 'redux/store';
import { formCounterSlice } from 'redux/formCounter';
import './formPage.css';
// import { getFormPath_perc } from 'utils/getFormPercentage';
import { shallowEqual } from 'utils/shallowEqual';
// import { getFilledForms } from 'api/rest/table_input';
// import { isEmptyObject } from 'utils/isEmptyObject';
import { FormsFactory } from 'utils/formsFactory';
// import { getKeysByTrueValue } from 'utils/getKeysBytrueValue';
import { useFormPath } from 'utils/useFormPath';
import api from 'api';
import { labelToKey } from 'utils/formLabelsToKey';
import { setAssessmentStartTimestamps } from 'redux/user/user-slice';
import { startAssessmentOnce } from 'utils/assessmentStart';
import { getActingProfileUserId } from 'utils/selectedAccount';

const OnboardingFormPage = () => {
    const params = useParams();
    const dispatch = useDispatch();

    // This component mounts in two contexts:
    //   (1) backoffice sales-onboarding — the route has an :id param (the
    //       client being edited); use it.
    //   (2) client flow (rendered inside CandidateDashboardWrapper) — no :id
    //       in the route; the authenticated user edits their own forms, so
    //       fall back to the logged-in user's id from Redux.
    // Without this fallback Number(params.id) is NaN in case (2) and we fire
    // GET /candidate_info/NaN/completed-forms → backend 500.
    const routeId = Number(params.id);
    const authUserId = useSelector((state: RootState) => state.user.entity.id);
    const candidateID = Number.isFinite(routeId) && routeId > 0 ? routeId : authUserId;
    const assessmentUserId = getActingProfileUserId() ?? candidateID;

    // const isSalesPerson = params?.['*'] && params['*'].includes('sales-onboarding');
    const { screen, purpose, showSpouse } = useSelector(
        (state: RootState) => state.formCounter,
        shallowEqual
    );
    const { setNumberForms, setCanEnableSubmitButton } = formCounterSlice.actions;

    const formPath = useFormPath(purpose);
    const [currFormName, setCurrFormName] = useState('');
    const [completedForms, setCompletedForms] = useState<Record<string, boolean>>({});
    const [fetchingCompletedForms, setFetchingCompletedForms] = useState(false);

    useEffect(() => {
        if (!Number.isFinite(assessmentUserId) || assessmentUserId <= 0) return;

        void startAssessmentOnce(assessmentUserId).then((timestamps) => {
            if (timestamps && assessmentUserId === authUserId) {
                dispatch(setAssessmentStartTimestamps(timestamps));
            }
        });
    }, [assessmentUserId, authUserId, dispatch]);

    useEffect(() => {
        dispatch(setNumberForms(formPath.length));
        setCurrFormName(formPath[screen - 1] ?? '');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [formPath, purpose, screen]);

    const engFormPath = useFormPath(purpose, candidateID, 'EN');
    const canEnableSubmitButton = engFormPath
        .slice(0, engFormPath.length - 1)
        .every((form: string) => {
            return completedForms[labelToKey[form]];
        });

    const getCompletedForms = useCallback(async () => {
        if (fetchingCompletedForms) return;
        if (!Number.isFinite(candidateID) || candidateID <= 0) return;

        setFetchingCompletedForms(true);
        const resp = await api.completedForms.getCompletedForms(candidateID);
        if (resp?.data) {
            setCompletedForms(resp.data);
        }
        setFetchingCompletedForms(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [candidateID]);

    useEffect(() => {
        getCompletedForms();
    }, [candidateID, currFormName, getCompletedForms]);

    useEffect(() => {
        dispatch(setCanEnableSubmitButton(canEnableSubmitButton));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [canEnableSubmitButton]);

    const currentForm = FormsFactory(currFormName, showSpouse);

    return (
        // <div className={isSalesPerson ? '' : 'formPageContainer'}>
        <div style={{ width: '100%' }}>
            {/* <div style={{ marginTop: isSalesPerson ? '0px' : '16px' }} className="formWrapper"> */}
            <div className="formWrapper">{currentForm}</div>
        </div>
    );
};

export default OnboardingFormPage;
